export default __webpack_public_path__ + "static/media/ic-previous-test.4767dc32.svg";